import { Step } from '../state/map';
import { StepConfig } from '../types/steps';
import {
  LocationMiniPanel,
  LocationExpandedPanel,
  PinsMiniPanel,
  PinsExpandedPanel,
  StyleMiniPanel,
  StyleExpandedPanel,
  LayersMiniPanel,
  LayersExpandedPanel,
  TextMiniPanel,
  TextExpandedPanel,
  SizeMiniPanel,
  SizeExpandedPanel,
  ExportMiniPanel,
  ExportExpandedPanel
} from '../components/mapmaker/mobile/panels';

export const stepConfigs: StepConfig[] = [
  {
    id: Step.Location,
    label: 'Location',
    miniPanel: LocationMiniPanel,
    expandedPanel: LocationExpandedPanel,
    description: 'Search and set your map location'
  },
  {
    id: Step.Pins,
    label: 'Pins',
    miniPanel: PinsMiniPanel,
    expandedPanel: PinsExpandedPanel,
    description: 'Add and manage map pins'
  },
  {
    id: Step.Style,
    label: 'Style',
    miniPanel: StyleMiniPanel,
    expandedPanel: StyleExpandedPanel,
    description: 'Choose your map style'
  },
  {
    id: Step.Layout,
    label: 'Layers',
    miniPanel: LayersMiniPanel,
    expandedPanel: LayersExpandedPanel,
    description: 'Toggle map layers'
  },
  {
    id: Step.Border,
    label: 'Text',
    miniPanel: TextMiniPanel,
    expandedPanel: TextExpandedPanel,
    description: 'Configure text and fonts'
  },
  {
    id: Step.Size,
    label: 'Size',
    miniPanel: SizeMiniPanel,
    expandedPanel: SizeExpandedPanel,
    description: 'Choose your paper size'
  },
];

// Helper function to get step config by ID
export const getStepConfig = (stepId: Step): StepConfig | undefined => {
  return stepConfigs.find(config => config.id === stepId);
};

// Helper function to get step index
export const getStepIndex = (stepId: Step): number => {
  return stepConfigs.findIndex(config => config.id === stepId);
};

// Helper function to get next step
export const getNextStep = (currentStep: Step): Step | null => {
  const currentIndex = getStepIndex(currentStep);
  if (currentIndex === -1 || currentIndex === stepConfigs.length - 1) {
    return null;
  }
  return stepConfigs[currentIndex + 1].id;
};

// Helper function to get previous step
export const getPreviousStep = (currentStep: Step): Step | null => {
  const currentIndex = getStepIndex(currentStep);
  if (currentIndex <= 0) {
    return null;
  }
  return stepConfigs[currentIndex - 1].id;
};
